import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import columns from "./Table/columns";
import data from "./Table/data";
import Filters from "./Table/Filters";
import Credits from "./Credits/Credits";
import InvitePopup from "../../Member/Invite/Popup";

import { useEnterpriseMembersContext } from "../../../contexts/EnterpriseMembersContext";
import { useInviteMembersContext } from "../../../contexts/InviteMembersContext";

export default function Table() {
  const { dispatch, actions, state } = useEnterpriseMembersContext();
  const {
    dispatch: inviteDispatch,
    actions: inviteActions,
    state: inviteState,
  } = useInviteMembersContext();

  const [keyword, setKeyword] = useState("");
  const [team, setTeam] = useState("");
  const [template, setTemplate] = useState("");

  useEffect(() => {
    actions.loadMembers(dispatch, state.enterpriseId, state.teamId);
  }, []);

  return (
    <>
      <Filters
        keyword={keyword}
        setKeyword={setKeyword}
        setTeam={setTeam}
        setTemplate={setTemplate}
      />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={data(state.members, keyword, team, template) || []}
          noDataComponent={
            <div className="mt20">
              {state.members == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
      <Credits />
      <InvitePopup />
    </>
  );
}
